import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LastPlayedGamesModule } from "../last-played-games/last-played-games.module";


import { GameComponent } from "./game.component";



@NgModule({
  declarations: [
    GameComponent
  ],
  imports: [
    CommonModule,
    LastPlayedGamesModule
  ],
  exports:[
    GameComponent
  ]
})
export class GameModule { }
